import React from "react";
import { buttonClass } from "../components/ui/Button";
import { Dialog } from "../components/ui/Dialog";
import { Select } from "../components/ui/Select";
import { FileField } from "../components/ui/FileField";
import { Checkbox } from "../components/ui/Checkbox";

const FilterModal = ({
  isOpen,
  onClose,
  // Filter values
  conditionFilterValue,
  setConditionFilterValue,
  faaFilterValue,
  setFAAFilterValue,
  customerFilterValue,
  setCustomerFilterValue,
  projectFilterValue,
  setProjectFilterValue,
  lastSeenFilterValue,
  setLastSeenFilterValue,
  firmwareFilterValue,
  setFirmwareFilterValue,
  escFilterValue,
  setEscFilterValue,
  // Options
  uniqueCustomers,
  uniqueProjects,
  uniqueFirmwares,
  uniqueEscVersions,
  // CSV
  csvFile,
  handleFileChange,
  useCSV,
  setUseCSV,
  droneIds,
}) => {
  const clearAllFilters = () => {
    setConditionFilterValue("");
    setFAAFilterValue("");
    setCustomerFilterValue("");
    setProjectFilterValue("");
    setLastSeenFilterValue("");
    setFirmwareFilterValue("");
    setEscFilterValue("");
  };

  const hasActiveFilters =
    conditionFilterValue ||
    faaFilterValue ||
    customerFilterValue ||
    projectFilterValue ||
    lastSeenFilterValue ||
    firmwareFilterValue ||
    escFilterValue;

  return (
    <Dialog
      open={!!isOpen}
      onClose={onClose}
      title="Filters"
      closeHint="Close filters"
      footer={(
        <>
          {hasActiveFilters && (
            <button
              onClick={clearAllFilters}
              className={buttonClass("danger-quiet", "md")}
            >
              Clear all
            </button>
          )}
          <button
            onClick={onClose}
            className={buttonClass("filled", "md")}
          >
            Apply Filters
          </button>
        </>
      )}
    >
        <div className="space-y-4">
          {/* Status Filter */}
          <div>
            <label className="block text-sm font-medium text-on-surface-variant mb-2">
              Status
            </label>
            <Select
              label="Status"
              value={conditionFilterValue}
              onChange={setConditionFilterValue}
              options={[
                { key: "", label: "All Statuses" },
                { key: "RTF", label: "Ready To Fly (RTF)" },
                { key: "Flag", label: "Flagged" },
                { key: "OOC", label: "Out of Commission" },
                { key: "NYC", label: "Not Yet Commissioned" },
              ]}
            />
          </div>

          {/* FAA Status Filter */}
          <div>
            <label className="block text-sm font-medium text-on-surface-variant mb-2">
              FAA Registration
            </label>
            <Select
              label="FAA registration"
              value={faaFilterValue}
              onChange={setFAAFilterValue}
              options={[
                { key: "", label: "All FAA Statuses" },
                { key: "Active", label: "Active" },
                { key: "Expires Soon", label: "Expires Soon" },
                { key: "Expired", label: "Expired" },
                { key: "Unregistered", label: "Unregistered" },
              ]}
            />
          </div>

          {/* Customer Filter */}
          <div>
            <label className="block text-sm font-medium text-on-surface-variant mb-2">
              Customer
            </label>
            <Select
              label="Customer"
              value={customerFilterValue}
              onChange={setCustomerFilterValue}
              options={[{ key: "", label: "All Customers" }, ...uniqueCustomers.map((customer) => ({ key: customer, label: customer }))]}
            />
          </div>

          {/* Project Filter */}
          <div>
            <label className="block text-sm font-medium text-on-surface-variant mb-2">
              Project
            </label>
            <Select
              label="Project"
              value={projectFilterValue}
              onChange={setProjectFilterValue}
              options={[{ key: "", label: "All Projects" }, ...uniqueProjects.map((project) => ({ key: project, label: project }))]}
            />
          </div>

          {/* Last Seen Filter */}
          <div>
            <label className="block text-sm font-medium text-on-surface-variant mb-2">
              Last Seen
            </label>
            <Select
              label="Last seen"
              value={lastSeenFilterValue}
              onChange={setLastSeenFilterValue}
              options={[
                { key: "", label: "Any Time" },
                { key: "1", label: "Past Month" },
                { key: "3", label: "Past 3 Months" },
                { key: "6", label: "More than 6 Months" },
                { key: "never", label: "Never Seen" },
              ]}
            />
          </div>

          {/* Firmware Filter */}
          {uniqueFirmwares && uniqueFirmwares.length > 0 && (
            <div>
              <label className="block text-sm font-medium text-on-surface-variant mb-2">
                Firmware
              </label>
              <Select
                label="Firmware"
                value={firmwareFilterValue}
                onChange={setFirmwareFilterValue}
                options={[{ key: "", label: "All Firmwares" }, ...uniqueFirmwares.map((fw) => ({ key: fw.hash, label: fw.label || fw.hash.substring(0, 12) }))]}
                className="font-mono"
              />
            </div>
          )}

          {/* ESC Version Filter */}
          {uniqueEscVersions && uniqueEscVersions.length > 0 && (
            <div>
              <label className="block text-sm font-medium text-on-surface-variant mb-2">
                ESC Version
              </label>
              <Select
                label="ESC version"
                value={escFilterValue}
                onChange={setEscFilterValue}
                options={[{ key: "", label: "All ESC Versions" }, ...uniqueEscVersions.map((esc) => ({ key: esc.key, label: `${esc.key} (${esc.count})` }))]}
              />
            </div>
          )}

          {/* CSV Filter */}
          <div>
            <label className="block text-sm font-medium text-on-surface-variant mb-2">
              Filter by CSV
            </label>
            <div className="flex items-center gap-3">
              <FileField accept=".csv" onChange={handleFileChange} className="flex-1" />
              {droneIds.length > 0 && (
                <Checkbox label="Use" checked={useCSV} onChange={(e) => setUseCSV(e.target.checked)} />
              )}
            </div>
            {droneIds.length > 0 && (
              <p className="text-xs text-on-surface-variant mt-1">
                {droneIds.length} drones in CSV
              </p>
            )}
          </div>
        </div>
    </Dialog>
  );
};

export default FilterModal;
